// extracted by mini-css-extract-plugin
module.exports = {"container":"closeButton_container__DiKT3","text":"closeButton_text__BjBgh"};